// src/utils/legacyPayments.js
// D-289 Phase 2 — legacy (before D-289) payment detection, in ONE place.
//
// WHY THIS EXISTS
// Before D-289, "Mark as Paid" edited a transport trip's LEDGER rows (one per
// stop) to "paid" but never updated the trip itself — transport_logs.status
// stayed "payment_pending". Such a trip IS paid. Every screen that shows a
// trip's paid state uses this one rule (Accounts, Transport).
// Detect-and-fallback: old rows and old trips are never edited.

export function legacyPaidTripIds(ledgerRows = []) {
  const byTrip = {};
  for (const r of ledgerRows) {
    if (r.reference_type !== "transport" || !r.reference_id) continue;
    (byTrip[r.reference_id] = byTrip[r.reference_id] || []).push(r);
  }
  const paid = new Set();
  for (const [tripId, rows] of Object.entries(byTrip)) {
    if (rows.length > 0 && rows.every((r) => r.status === "paid")) paid.add(tripId);
  }
  return paid;
}